import { render, staticRenderFns } from "./IndexDoBrushChange.vue?vue&type=template&id=5049d406&scoped=true"
import script from "./IndexDoBrushChange.vue?vue&type=script&lang=js"
export * from "./IndexDoBrushChange.vue?vue&type=script&lang=js"
import style0 from "./IndexDoBrushChange.vue?vue&type=style&index=0&id=5049d406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049d406",
  null
  
)

export default component.exports